import { NgModule, ModuleWithProviders, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZendeskModel } from './zendesk.model';
import { ZendeskService } from './zendesk.service';

@NgModule({
  imports: [
    CommonModule
  ]
})
export class ZendeskModule {
  static forRoot(zendeskConfig: Type<ZendeskModel>): ModuleWithProviders<ZendeskModule> {
    return {
      ngModule: ZendeskModule,
      providers: [
        {provide: zendeskConfig, useClass: zendeskConfig },
        {provide: ZendeskService, useClass: ZendeskService, deps: [zendeskConfig] }
      ]
    };
  }
}

export {
    ZendeskService,
    ZendeskModel
};
